import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useInspectionAttributes() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/inspection-attribute/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useListByProjectId() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.get(`/v1/inspection-attribute/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useUpdateSingleAttribute() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.put(`/v1/inspection-attribute/update`, params).then(parseSuccessResponseData),
        });
    }

    return { useCreate, useListByProjectId, useUpdateSingleAttribute };
}
